import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import Icon from "@mui/material/Icon";
import { useState } from "react";
import { ReleaseNotesDialog } from "../releaseNotesDialog";
import { getConnectorVersionDownloadUrl } from "api/ExecutorServiceApi";
import { toast } from "react-toastify";

export const VersionsMenu = ({ version, setVersionToDelete, handleUpdateVersion, isReadOnlyAccess }) => {
   const [versionsMenu, setVersionsMenu] = useState(null);
   const [showReleaseNotes, setShowReleaseNotes] = useState(false);

   const handleOpenVersionsMenu = (event) => {
      setVersionsMenu(event.currentTarget);
   };

   const handleCloseVersionsMenu = () => {
      setVersionsMenu(null);
   };

   const handleDownloadVersion = async () => {
      try {
         const configFiles = version.config_files.split(",");

         const zipUrl =
            configFiles.find((file) => decodeURIComponent(new URL(file).pathname.split("/").pop()) === version.file_name) ||
            configFiles.find((file) => new URL(file).pathname.toLowerCase().endsWith(".zip"));

         if (!zipUrl) {
            toast.error("The ZIP file for this connector version could not be found.");
            return;
         }

         const response = await getConnectorVersionDownloadUrl(zipUrl);

         if (response?.resultObject?.data) {
            const link = document.createElement("a");
            link.href = response.resultObject.data;
            link.target = "_blank";
            link.click();
         } else toast.error(response?.message || "Unable to generate a download link for this connector version.");
      } catch (error) {
         console.error(error);
         toast.error("Unable to download this connector version.");
      }
   };

   const handleSetVersionToDelete = () => {
      setVersionToDelete();
      handleCloseVersionsMenu();
   };

   const handleOpenReleaseNotes = () => {
      setShowReleaseNotes(true);
      handleCloseVersionsMenu(null);
   };

   return (
      <>
         <Tooltip title="More Actions" placement="top">
            <Icon fontSize="default" onClick={handleOpenVersionsMenu} sx={{ cursor: "pointer" }}>
               {"more_horiz_icon"}
            </Icon>
         </Tooltip>
         <Menu
            anchorEl={versionsMenu}
            anchorOrigin={{ vertical: "top", horizontal: "left" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            open={Boolean(versionsMenu)}
            onClose={handleCloseVersionsMenu}
            keepMounted
         >
            {isReadOnlyAccess
               ? [
                    <MenuItem key="release" onClick={handleOpenReleaseNotes}>
                       Release Notes
                    </MenuItem>
                 ]
               : [
                    <MenuItem key="download" onClick={handleDownloadVersion}>
                       Download
                    </MenuItem>,
                    <MenuItem key="release" onClick={handleOpenReleaseNotes}>
                       Release Notes
                    </MenuItem>,
                    <MenuItem key="remove" onClick={handleSetVersionToDelete}>
                       Remove
                    </MenuItem>
                 ]}
         </Menu>
         <ReleaseNotesDialog open={showReleaseNotes} onClose={() => setShowReleaseNotes(false)} version={version} handleUpdateVersion={handleUpdateVersion} isReadOnlyAccess={isReadOnlyAccess} />
      </>
   );
};
